import { PublicClientApplication } from '@azure/msal-browser'
import type { Configuration } from '@azure/msal-browser'

const config: Configuration = {
  auth: {
    clientId: '7f89458c-5e08-4629-953c-510b04264730',
    authority: 'https://login.microsoftonline.com/cbf40500-f598-477c-a2e6-f9c6f17f2e25',
    redirectUri: window.location.origin + '/login',
    postLogoutRedirectUri: window.location.origin + '/login',
  },
  cache: {
    cacheLocation: 'localStorage',
  },
}

let _instance: PublicClientApplication | null = null

export async function getMsalInstance(): Promise<PublicClientApplication> {
  if (!_instance) {
    _instance = new PublicClientApplication(config)
    await _instance.initialize()
  }
  return _instance
}

export const MSAL_SCOPES = ['User.Read']
